export const shanghaiAbout =
  'Zagolicajte vaša čula i prepustite se čarima dalekog Istoka u primamljivoj i opuštajućoj atmosferi koja će učiniti da mislima odlutate na drugi kraj svijeta. Sa tradicijom starom preko četvrt vijeka restoran Shanghai, ponudiće vam najraznovrsnija kineska jela kao i najbolji sushi u gradu. Vrhunski dekorisana jela, pripremljena od originalnih namirnica od strane kineskih kuvara koji će vas svojim specijalitetima odvesti u svijet izvandredne azijske kuhinje i kulture. Kako bi vaš užitak bio kompletan u ponudi našeg restorana možete pronaći domaću kinesku rakiju, Sake vino i japansko pivo.';
export const lavillaAbout =
  'Satkan od topline pijeska i svježine morske obale, nježnog sunčanog dana i prijatnog povjetarca restoran LaVilla odiše mediteranskim stilom i nudi vam šareni gastronomski put uz profesionalnu uslužnost osoblja. Na meniju možete pronaći širok asortiman jela. Uz prijedloge našeg osoblja napravite pravi izbor i uživajte u ukusima koji će probuditi sva vaša čula. Od prvoklasne ponude morskih specijaliteta, specijaliteta italijanske kuhinje i mesa vrhunskog kvaliteta pripremljenih sa velikom predanošću iskusnih kuvara, LaVilla će ostaviti i najprobirljivije goste bez daha.';
export const abstract =
  'Ispred zidina vjekovima Starog grada, sa očaravajućim pogledom na marinu, ušuškana su dva restorana koja pružaju udobnost i nesvakidašnji gastronomski užitak. Naši restorani su idealna mjesta za romantične večere, porodična okupljanja i uživanje uz opuštenu atmosferu u društvu prijatelja. Na vama je da li ćete se prepustiti ukusima tradicionalne mediteranske kuhinje u restoranu LaVilla ili ćete isprobati azijsku kuhinju koja obiluje bogatstvom ukusa u restoranu Shanghai.';

const restaurants = [
  {
    id: 'shanghai',
    name: 'Shanghai Restaurant',
    background: require('../../../assets/images/food/shanghai/shanghai1.jpeg'),
    about: shanghaiAbout,
    abstract: abstract,
    title: 'Shanghai Restaurant',
    subtitle: 'Chinese & Sushi Cuisine',
    logoMain: require('../../../assets/images/shanghaiLogoSec.png'),
    logo: require('../../../assets/images/shanghaiLogo.png'),
    color: '#0d4255c4',
    gallery: [
      require('../../../assets/images/food/shanghai/shanghai1.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai2.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai3.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai4.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai5.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai6.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai7.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai8.jpeg'),
      require('../../../assets/images/food/shanghai/shanghai9.jpeg'),
    ],
  },
  {
    id: 'lavilla',
    name: 'LaVilla Restaurant',
    background: require('../../../assets/images/food/lavilla/lavilla1.jpeg'),
    about: lavillaAbout,
    abstract: abstract,
    title: 'LaVilla Restaurant',
    subtitle: 'Mediterranean Cuisine',
    logoMain: require('../../../assets/images/laVillaLogoSec.png'),
    logo: require('../../../assets/images/laVillaLogo.png'),
    color: '#0d4255c4',
    gallery: [
      require('../../../assets/images/food/lavilla/lavilla1.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla2.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla3.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla4.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla5.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla6.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla7.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla8.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla9.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla10.jpeg'),
      require('../../../assets/images/food/lavilla/lavilla11.jpeg'),
    ],
  },
];

export default restaurants;